import * as Segment from './tools/segment';

/**
 * Track when page was viewed.
 */
export const viewPage = (name: string): Promise<void> => {
  return Segment.page(name);
};
